<template>
  <!--右侧客服悬浮窗-->
  <div class="window">
    <div class="card">
      <div class="bkg" />
      <div class="item" @click="to1688">
        <svg
          slot="reference"
          class="pic_1688"
          viewBox="0 0 91 36"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.987 7.25C25.995-.97 34.829-.048 36.637.115l-1.691 6.218c-2.121.067-6.575.429-9.759 4.785-.682.933-1.216 1.972-1.636 3.04l.18-.117c1.367-.835 3.05-1.258 5.004-1.257 1.266 0 2.528.22 3.752.655a9.55 9.55 0 013.362 2.07c.994.944 1.793 2.152 2.38 3.592.586 1.44.882 3.147.882 5.073 0 1.92-.34 3.649-1.012 5.138-.663 1.477-1.56 2.728-2.663 3.718a11.297 11.297 0 01-3.728 2.223 12.43 12.43 0 01-4.24.748c-1.754 0-3.37-.266-4.803-.792a9.336 9.336 0 01-3.797-2.583c-1.032-1.168-1.827-2.656-2.367-4.422-.365-1.182-.604-2.542-.718-4.054-.098-.775-.159-2.607.072-4.917l.022-.243.002-.002c.381-3.53 1.452-8.102 4.108-11.736zM12.507 0l-.009 36-6.784-.002.007-27.699-3.47 1.059L0 3.968 12.507 0zm40.98 0c1.408 0 2.74.21 3.958.626 1.238.425 2.326 1.03 3.236 1.798a8.798 8.798 0 012.25 2.906c.565 1.176.85 2.482.85 3.886 0 2.216-.584 4.081-1.733 5.544a11.529 11.529 0 01-1.864 1.883c.097.06.194.12.29.183.85.55 1.628 1.242 2.314 2.057a10.57 10.57 0 011.72 2.932c.45 1.134.68 2.456.68 3.924 0 1.856-.36 3.476-1.069 4.816a9.124 9.124 0 01-2.764 3.217 11.107 11.107 0 01-3.763 1.718 16.82 16.82 0 01-4.113.51c-1.414 0-2.807-.172-4.14-.512a11.085 11.085 0 01-3.733-1.718 9.11 9.11 0 01-2.773-3.228c-.703-1.33-1.062-2.95-1.061-4.809 0-1.476.23-2.793.683-3.915a10.733 10.733 0 011.716-2.891 11.133 11.133 0 012.273-2.066c.11-.075.22-.148.332-.22a11.737 11.737 0 01-1.867-1.916c-1.144-1.479-1.723-3.333-1.722-5.514 0-1.406.287-2.714.854-3.884a8.736 8.736 0 012.248-2.908c.913-.767 2.001-1.37 3.233-1.794C50.746.209 52.08 0 53.487 0zm25.811 0c1.41 0 2.74.21 3.958.626 1.24.425 2.327 1.03 3.236 1.798a8.774 8.774 0 012.25 2.907c.566 1.175.852 2.48.85 3.885 0 2.216-.583 4.081-1.733 5.544a11.53 11.53 0 01-1.863 1.883c.097.06.194.12.29.184.85.55 1.628 1.241 2.314 2.056a10.57 10.57 0 011.72 2.932c.45 1.134.68 2.456.68 3.924 0 1.856-.36 3.476-1.07 4.816a9.133 9.133 0 01-2.763 3.217 11.126 11.126 0 01-3.763 1.718c-1.347.34-2.731.51-4.115.51a16.79 16.79 0 01-4.139-.512 11.092 11.092 0 01-3.733-1.718 9.107 9.107 0 01-2.772-3.228c-.703-1.33-1.063-2.95-1.062-4.809 0-1.476.23-2.793.684-3.915a10.748 10.748 0 011.714-2.891 11.156 11.156 0 012.606-2.286 11.702 11.702 0 01-1.866-1.916c-1.144-1.478-1.725-3.333-1.724-5.514 0-1.406.289-2.714.855-3.884A8.746 8.746 0 0172.1 2.419c.913-.767 2.001-1.37 3.233-1.794C76.558.209 77.89 0 79.298 0zM53.372 20h-.018s-.039.009-.121.035l-.12.04a11.74 11.74 0 00-1.304.576c-1.111.556-2.08 1.2-2.773 2.101-.693.901-1.52 2.942-.1 5.006 1.386 2.016 3.833 2.115 4.424 2.108h.065c.683-.002 3.003-.158 4.337-2.106 1.412-2.063.59-4.104-.098-5.005-.689-.902-1.648-1.553-2.757-2.104-1.11-.55-1.535-.65-1.535-.65zm26.078 0h-.019s-.039.009-.121.035l-.12.04a11.74 11.74 0 00-1.304.576c-1.11.556-2.08 1.2-2.773 2.101-.693.901-1.52 2.942-.1 5.006 1.386 2.016 3.833 2.115 4.424 2.108h.065c.683-.002 3.003-.158 4.337-2.105 1.412-2.064.592-4.105-.098-5.006-.689-.902-1.648-1.553-2.756-2.103-1.11-.551-1.535-.652-1.535-.652zm-52.011-.984c-2.664-.001-4.823 2.177-4.824 4.863v1.023c0 2.685 2.158 4.863 4.821 4.864h.527c2.663 0 4.822-2.176 4.823-4.862v-1.022c0-2.686-2.158-4.865-4.82-4.866zM53.535 6.134h-.122c-.539.003-2.306.13-3.325 1.593-1.086 1.562-.455 3.107.075 3.79.53.681 1.268 1.174 2.121 1.59.853.417 1.181.493 1.181.493h.014s.343-.076 1.188-.492c.855-.421 1.6-.909 2.133-1.59.533-.682 1.169-2.227.077-3.79-1.066-1.524-2.95-1.599-3.403-1.594zm25.811 0h-.122c-.538.003-2.306.13-3.325 1.593-1.086 1.562-.455 3.107.075 3.79.53.681 1.268 1.174 2.121 1.59.854.417 1.181.493 1.181.493h.014s.343-.076 1.188-.492c.856-.421 1.6-.909 2.133-1.59.534-.682 1.17-2.227.078-3.79-1.067-1.524-2.95-1.599-3.404-1.594z"
            fill="#FF4000"
            fill-rule="evenodd"
          />
        </svg>
      </div>

      <el-popover placement="left-start" trigger="hover" :visible-arrow="false">
        <div class="qrcode-card">
          <img :src="wxQrCode" />
        </div>
        <div slot="reference" class="item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="pic_wx"
            viewBox="0 0 25 25"
          >
            <g fill="none" fill-rule="evenodd">
              <path
                fill="#0082F0"
                d="M24.27 6.9a10.746 10.746 0 00-1.945-2.764C20.295 2.034 17.453.68 14.322.323a14.773 14.773 0 00-1.656-.096c-.511 0-1.044.03-1.585.089-3.144.342-6.002 1.69-8.047 3.792a10.757 10.757 0 00-1.955 2.757 9.634 9.634 0 00-1.003 4.277c0 1.909.58 3.79 1.678 5.442a14.96 14.96 0 002.302 2.634v.002l-.378 2.974c-.015.04-.031.08-.04.123-.01.039-.012.079-.016.119-.002.03-.01.06-.01.091 0 .033.008.065.01.098.05.489.458.872.96.872.175 0 .337-.05.478-.131l.014-.008c.02-.012.042-.023.062-.036l.903-.454 2.69-1.352a13.93 13.93 0 002.35.453 14.54 14.54 0 003.243-.009 14.092 14.092 0 003.173-.742 1.752 1.752 0 01-1.192-1.832c-.72.23-1.472.393-2.25.482a12.172 12.172 0 01-2.716.008c-.09-.01-.182-.025-.274-.037a11.976 11.976 0 01-1.78-.373 1.217 1.217 0 00-.37-.057c-.2 0-.392.053-.588.154-.026.014-.05.025-.076.04l-2.21 1.303-.096.057-.003.001c-.047.028-.075.039-.1.039a.15.15 0 01-.146-.153l.085-.345.098-.375.162-.614.179-.686a.93.93 0 00-.334-1.033 9.906 9.906 0 01-.923-.777c-.5-.475-.94-.994-1.31-1.55-.869-1.308-1.328-2.792-1.328-4.293 0-1.164.266-2.297.79-3.366a8.633 8.633 0 011.569-2.21c1.68-1.728 4.045-2.837 6.656-3.12.454-.05.901-.075 1.328-.075.449 0 .916.027 1.388.08 2.599.296 4.949 1.41 6.617 3.138a8.618 8.618 0 011.56 2.215 7.584 7.584 0 01.778 3.338c0 .12-.007.24-.013.36a1.746 1.746 0 012.149.251c.03.03.054.062.08.093a9.11 9.11 0 00.031-.739 9.634 9.634 0 00-.986-4.243"
              />
              <path
                fill="#FB6500"
                d="M24.149 22.148a1.7 1.7 0 00-.21-.035 5.377 5.377 0 01-2.996-1.67v.001a.418.418 0 10-.534.64c.041.04.082.078.121.118a5.39 5.39 0 011.478 2.761 1.715 1.715 0 00.059.356 1.749 1.749 0 002.926.777 1.754 1.754 0 00-.844-2.948"
              />
              <path
                fill="#0082F0"
                d="M29.944 17.673a1.75 1.75 0 00-2.98 1.056 5.388 5.388 0 01-1.667 2.999.419.419 0 10.641.534l.117-.121a5.376 5.376 0 012.758-1.48 1.71 1.71 0 00.355-.058 1.754 1.754 0 00.776-2.93"
              />
              <path
                fill="#2DBC00"
                d="M22.53 12.717a1.754 1.754 0 001.054 2.982 5.376 5.376 0 012.996 1.67.419.419 0 10.534-.641 5.389 5.389 0 01-1.6-2.879 1.625 1.625 0 00-.058-.355 1.75 1.75 0 00-2.926-.777"
              />
              <path
                fill="#FC0"
                d="M20.543 19.19a1.93 1.93 0 00.015-.106 5.393 5.393 0 011.668-3 .42.42 0 10-.64-.534 5.375 5.375 0 01-2.876 1.6 1.73 1.73 0 00-.355.06 1.754 1.754 0 00-.776 2.93 1.75 1.75 0 002.964-.95"
              />
            </g>
          </svg>
        </div>
      </el-popover>

      <el-popover
        placement="left"
        trigger="hover"
        width="330"
        :visible-arrow="false"
      >
        <div class="contact-popover">
          <div v-if="$i18n.locale !== 'en_US'">
            <!-- 终端客户 -->
            <div class="contact-section">
              <h3>
                <img src="@/assets/images/contact_left.png" alt="" />
                终端客户
                <img src="@/assets/images/contact_right.png" alt="" />
              </h3>
              <p>华南北方区域：18766035093 18315885301</p>
              <p>东南华北区域：15806833406</p>
              <p>沪(苏州)区域：18818201776</p>
              <p>江苏(不含苏州)区域：13346271558</p>
            </div>

            <!-- 贸易客户 -->
            <div class="contact-section">
              <h3>
                <img src="@/assets/images/contact_left.png" alt="" />
                贸易客户
                <img src="@/assets/images/contact_right.png" alt="" />
              </h3>
              <p>服务热线：15101074295</p>
            </div>

            <!-- 技术支持 -->
            <div class="contact-section">
              <h3>
                <img src="@/assets/images/contact_left.png" alt="" />

                技术支持
                <img src="@/assets/images/contact_right.png" alt="" />
              </h3>
              <p>服务热线：18766032705</p>
            </div>

            <div class="contact-line" />

            <div class="contact-area">
              <div>华南北方区域：</div>
              <div>
                广东、广西、江西、云南、贵州、内蒙古、黑龙江、吉林、辽宁、河北、天津、北京、河南、陕西、山西
              </div>
            </div>
            <div class="contact-area">
              <div>东南华北区域：</div>
              <div>安徽、湖南、湖北、浙江、福建、山东、四川、重庆</div>
            </div>
          </div>
          <div v-else>
            <div class="contact-section">
              <h3>
                <img src="@/assets/images/contact_left.png" alt="" />
                Sales Team
                <img src="@/assets/images/contact_right.png" alt="" />
              </h3>
              <p>Tel/Teams/WeChat：+86 15275700756</p>
              <p>Whatsapp：+86 18562157525</p>
              <p>Email：elena@tycelec.com</p>
            </div>
            <div class="contact-section">
              <h3>
                <img src="@/assets/images/contact_left.png" alt="" />
                Technical Support
                <img src="@/assets/images/contact_right.png" alt="" />
              </h3>
              <p>Tel/Teams/WeChat：+86 15275700756</p>
              <p>Whatsapp：+86 18562157525</p>
              <p>Email：elena@tycelec.com</p>
            </div>
          </div>
        </div>
        <div slot="reference" class="item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            t="1665540699252"
            class="icon pic_phone"
            viewBox="0 0 1024 1024"
            version="1.1"
            p-id="2548"
          >
            <path
              d="M871.673333 770.813333a53.393333 53.393333 0 0 1 0 75.42l-37.713333 37.713334c-27.866667 27.866667-64.52 44.84-108.946667 50.46a264.333333 264.333333 0 0 1-33.213333 2.04c-32.333333 0-67.22-5.46-104.146667-16.32C487.42 890.666667 382 824.226667 290.9 733.1S133.333333 536.586667 103.873333 436.346667c-14.666667-49.94-19.493333-96.153333-14.28-137.333334 5.62-44.426667 22.593333-81.08 50.46-108.946666l37.713334-37.713334a53.393333 53.393333 0 0 1 75.42 0l165.94 165.933334a53.4 53.4 0 0 1 0 75.426666l-37.713334 37.686667c-21.333333 21.333333-0.1 90.413333 60.34 150.846667s129.486667 81.7 150.846667 60.34l37.713333-37.713334a53.4 53.4 0 0 1 75.426667 0zM597.333333 384a42.713333 42.713333 0 0 1 42.666667 42.666667 21.333333 21.333333 0 0 0 42.666667 0 85.426667 85.426667 0 0 0-85.333334-85.333334 21.333333 21.333333 0 0 0 0 42.666667z m314.5-90.2A341.073333 341.073333 0 0 0 597.333333 85.333333a21.333333 21.333333 0 0 0 0 42.666667c164.666667 0 298.666667 134 298.666667 298.666667a21.333333 21.333333 0 0 0 42.666667 0 339.153333 339.153333 0 0 0-26.833334-132.866667zM597.333333 256c94.106667 0 170.666667 76.56 170.666667 170.666667a21.333333 21.333333 0 0 0 42.666667 0 213.333333 213.333333 0 0 0-213.333334-213.333334 21.333333 21.333333 0 0 0 0 42.666667z"
              fill="#0b94fd"
              p-id="2549"
            />
          </svg>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "SuspConsult",
  data() {
    return {
      selected: null,
      wxQrCode: require("/src/assets/images/wxQrCode.jpg"),
      appQrcode: require("../assets/images/appQrcode.jpg"),
    };
  },
  methods: {
    router() {
      return router;
    },
    select(val) {
      this.selected = val;
    },
    to1688() {
      window.open(
        "https://detail.1688.com/offer/682349952014.html?spm=a2615.2177701.autotrace-offerGeneral.1.2f7c61ddZBLOud"
      );
    },
  },
};
</script>

<style scoped lang="less">
.window {
  display: flex;
  position: fixed;
  right: 10px;
  top: 300px;
}
.card {
  height: 200px;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 15px;
  backdrop-filter: blur(20px);
}

.bkg {
  border-radius: 15px;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  z-index: -1;
}

.item {
  text-align: center;
  height: 60px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
}
.contact-popover {
  border-radius: 12px;
  .contact-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    h3 {
      margin: 5px 0;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #103f9b;
      img {
        height: 16px;
        width: 16px;
        margin: 0 10px;
      }
    }
    p {
      font-size: 14px;
      color: #666;
      margin: 5px 0;
    }
  }
  .contact-line {
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
  }

  .contact-area {
    display: flex;
    margin: 10px 0;
    > div:nth-child(1) {
      width: 115px;
      font-size: 14px;
      color: #333333;
      text-align: right;
      line-height: 26px;
    }
    > div:nth-child(2) {
      flex: 1;
      padding-right: 8px;
      font-size: 14px;
      color: #666666;
      line-height: 26px;
    }
  }
}

.qrcode-card {
  height: 206px;
  width: 206px;
  > img {
    height: 100%;
  }
}
.tel-card {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 8px;
  background: white;
  height: 50px;
  line-height: 50px;
  width: 200px;
  display: flex;
  position: absolute;
  right: 0;
  top: 135px;
  font-size: 15px;
}

.qq-card {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 8px;
  background: white;
  height: 50px;
  line-height: 50px;
  width: 200px;
  display: flex;
  position: absolute;
  right: 0;
  top: 20px;
  font-size: 15px;
}
/deep/ .el-card__body {
  padding: 0;
}
.text-content {
  margin-left: 10px;
  line-height: 50px;
  height: 50px;
}
.pic_1688 {
  width: 45px;
  height: 36px;
}
.pic_wx {
  width: 44px;
  height: 30px;
}
.pic_phone {
  width: 30px;
  height: 30px;
}
</style>
